import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';
import { Btn } from 'components';

/**
 * 메인 : 다크 / 로그인(X/gray_opacity_50) / 회원가입(blue_900/gray_opacity_50)
 * 회원가입 : 화이트 / 로그인(blue_opacity_100/blue_900)
 * 로그인 전 : 화이트 / 회원가입(blue_opacity_100/blue_900)
 * 로그인 후 : 화이트 / 로그아웃(red_opacity_100/red_900)
 */

interface Props {
  isMain: boolean;
}

export const HeaderContainer = styled.div<Props>`
  z-index: 1;
  padding: 0 20px;
  position: fixed;
  width: 100%;
  height: 60px;
  min-height: 60px;
  line-height: 60px;
  top: 0;
  left: 0;
  display: flex;
  align-content: center;

  ${(props) =>
    props.isMain
      ? css`
          background-color: ${palette('gray_opacity_800')};
          ${BtnLogIn} {
            background-color: ${palette('transparent')};
            color: ${palette('gray_opacity_50')};
          }
          ${BtnSignUp} {
            background-color: ${palette('blue_900')};
            color: ${palette('gray_opacity_50')};
          }
        `
      : css`
          background-color: ${palette('gray_opacity_50')};
          border-bottom: 1px solid ${palette('gray_opacity_200')};
        `}
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  max-width: 940px;
  margin: 0 auto;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NameLabelWrapper = styled.div`
  ${theme('fontStyle.body2')}
  margin-left: 12px;
`;

export const BtnContainer = styled.div`
  display: flex;
  align-items: center;
`;

const btnCommonCSS = css`
  ${theme('fontStyle.body2')}
  border-radius: 8px;
  margin-left: 12px;
  width: 90px;
  height: 32px;
`;

export const BtnLogIn = styled(Btn)`
  ${btnCommonCSS}
  background-color: ${palette('blue_opacity_100')};
  color: ${palette('blue_900')};
`;

export const BtnLogOut = styled(Btn)`
  ${btnCommonCSS}
  background-color: ${palette('red_opacity_100')};
  color: ${palette('red_900')};
`;

export const BtnSignUp = styled(Btn)`
  ${btnCommonCSS}
  background-color: ${palette('blue_opacity_100')};
  color: ${palette('blue_900')};
`;

export const BtnBack = styled(Btn)`
  width: 100px;
  background-color: ${palette('transparent')};
  text-align: left;
`;

export const IconWrapper = styled.div`
  width: 34px;
  height: 34px;
  margin-right: 6px;
  background: ${palette('gray_neautral_800')};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
